import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Globe, ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';
import { AriaLogo } from './AriaLogo';
import { Footer } from './Footer';

/**
 * Lightweight public shell for legal/info pages (guide, terms, privacy, contact).
 * Accessible without authentication.
 */
export const LegalLayout = ({ children }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const toggleLanguage = () => {
    i18n.changeLanguage(i18n.language === 'fr' ? 'en' : 'fr');
  };

  return (
    <div className="min-h-screen bg-[hsl(210,25%,6%)] grain-overlay flex flex-col" data-testid="legal-layout">
      <header className="h-16 bg-[hsl(210,18%,7%)]/90 backdrop-blur-md border-b border-border">
        <div className="h-full max-w-[1440px] mx-auto px-4 md:px-6 flex items-center justify-between">
          <div
            className="flex items-center gap-3 cursor-pointer"
            onClick={() => navigate('/')}
            data-testid="legal-logo"
          >
            <AriaLogo size={36} className="shrink-0" />
            <div>
              <h1 className="text-sm font-semibold text-foreground leading-none">{t('app.title')}</h1>
              <p className="text-[10px] text-muted-foreground mt-0.5">{t('app.subtitle')}</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Button
              variant="ghost"
              size="sm"
              onClick={toggleLanguage}
              className="gap-1.5 text-muted-foreground hover:text-foreground"
              data-testid="legal-language-toggle"
            >
              <Globe size={16} />
              <span className="text-xs font-semibold uppercase">{i18n.language}</span>
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={() => navigate('/')}
              className="gap-1.5 text-xs"
              data-testid="legal-back-button"
            >
              <ArrowLeft size={14} />
              {t('footer.back_to_app')}
            </Button>
          </div>
        </div>
      </header>

      <main className="flex-1 w-full max-w-[900px] mx-auto px-4 md:px-6 py-8 md:py-10">
        {children}
      </main>

      <Footer />
    </div>
  );
};

export default LegalLayout;
